<template>
  <div>
    <div class="container_box" v-if="warehouseListTalg">
      <div class="flowChart_box">
        <!--选择仓库-->
        <div class="select_warehouse_box">
          <h2 class="title">{{ warehouseName }}</h2>
          <Dropdown @on-click="warehouseChange" transfer>
            <div class="cursor">
              <span>{{ $t('key1002644') }}</span>
              <Icon type="ios-arrow-down"></Icon>
            </div>
            <DropdownMenu slot="list">
              <template v-for="item in ymsWarehouseData">
                <DropdownItem :name="item.ymsWarehouseId">{{ item.name }}</DropdownItem>
              </template>
            </DropdownMenu>
          </Dropdown>
        </div>
        <!--流程图-->
        <div class="processConfiguration_content">
          <div class="processConfiguration_box">
            <!--提单揽收-->
            <div class="processConfiguration_box_item">
              <h2 class="title">{{ $t('key1002645') }}</h2>
              <div class="process_status_box">{{ $t('key1002646') }}</div>
            </div>
            <!--右箭头-->
            <div class="right_arrow_box">
              <span class="line_box_style"></span>
              <span class="arrow_style"></span>
            </div>
            <!--提单入库-->
            <div class="processConfiguration_box_item">
              <h2 class="title">{{ $t('key1002647') }}</h2>
              <div class="process_status_box">{{ $t('key1002646') }}</div>
            </div>
            <!--右箭头-->
            <div class="right_arrow_box">
              <span class="line_box_style"></span>
              <span class="arrow_style"></span>
            </div>
            <!--入库分拣-->
            <div class="processConfiguration_box_item">
              <span class="text" @click="sortSettingsModal = true">{{ $t('key1000669') }}</span>
              <h2 class="title">{{ $t('key1002648') }}</h2>
              <div class="process_status_box">{{ $t('key1002646') }}</div>
              <Checkbox class="process_status_box" :true-value="1" :false-value="0"
                v-model="extremeDeliveryMode">{{ $t('key1002649') }}
              </Checkbox>
              <Checkbox v-if="extremeDeliveryMode" :true-value="1" :false-value="0"
                class="process_status_box" v-model="sortingSticker">{{ $t('key1002650') }}
              </Checkbox>
            </div>
          </div>
          <div class="erect_box">
            <!--商品上架-->
            <div class="processConfiguration_box_item">
              <h2 class="title">{{ $t('key1002651') }}</h2>
              <div class="process_status_box">{{ $t('key1002646') }}</div>
            </div>
            <!--下箭头-->
            <div class="down_arrow_box">
              <span class="line_box_style"></span>
              <span class="arrow_style"></span>
            </div>
            <!--拣货-->
            <div class="processConfiguration_box_item">
              <h2 class="title">{{ $t('key1001743') }}</h2>
              <div class="process_status_box">{{ $t('key1002646') }}</div>
            </div>
            <!--下箭头-->
            <div class="down_arrow_box">
              <span class="line_box_style"></span>
              <span class="arrow_style"></span>
            </div>
          </div>
          <div class="processConfiguration_box" style="margin-left: 332px;">
            <!--多品分拣-->
            <div class="processConfiguration_box_item">
              <h2 class="title">{{ $t('key1002652') }}</h2>
              <div class="process_status_box">{{ $t('key1002646') }}</div>
              <Checkbox class="process_status_box" v-model="singleItemTask" :disabled="true">{{ $t('key1002653') }}</Checkbox>
            </div>
            <!--右箭头-->
            <div class="right_arrow_box">
              <span class="line_box_style"></span>
              <span class="arrow_style"></span>
            </div>
            <!--包装作业-->
            <div class="processConfiguration_box_item">
              <h2 class="title">{{ $t('key1002654') }}</h2>
              <div class="process_status_box">{{ $t('key1002646') }}</div>
            </div>
            <!--右箭头-->
            <div class="right_arrow_box">
              <span class="line_box_style"></span>
              <span class="arrow_style"></span>
            </div>
            <!--物流分拣-->
            <div class="processConfiguration_box_item">
              <h2 class="title">{{ $t('key1002655') }}</h2>
              <div class="process_status_box">{{ $t('key1002646') }}</div>
            </div>
          </div>
          <!--默认走贴单+上架容器-->
          <div class="shelving_container_box">
            <!--左箭头-->
            <div class="left_arrow_box">
              <span class="arrow_style"></span>
              <span class="line_box_style"></span>
            </div>
            <span>{{ $t('key1002656') }}</span>
            <span class="vertical_line"></span>
            <div class="sticker_item" v-if="!sortingSticker">
              <span class="sticker_line">{{ $t('key1002657') }}</span>
            </div>
          </div>
          <!--极速出库模式-->
          <div class="extreme_delivery_box" v-if="extremeDeliveryMode">
            <!--直线拐角-->
            <div class="straight_corner_box"></div>
            <div class="straight_line_1">
              {{ $t('key1002658') }}
              <span class="arrow_style_green"></span>
            </div>
            <div class="straight_line_2">
              {{ $t('key1002659') }}
              <span class="arrow_style_green"></span>
            </div>
            <div class="straight_line_3" v-if="!sortingSticker">
              {{ $t('key1002660') }}
            </div>
            <div class="straight_line_4">
              {{ $t('key1002661') }}
            </div>
            <div class="straight_line_5">
              <span class="arrow_style"></span>
              <span class="line_box_style"></span>
            </div>
            <div class="straight_line_6" v-if="!sortingSticker">
              {{ $t('key1002662') }}
            </div>
          </div>
        </div>
      </div>
      <!--操作按钮-->
      <div class="options_content" v-if="getPermission('erpCommonSettingParam_saveOrUpdatePickupParam')">
        <Button class="mr15" type="primary" @click="processConfigurationBtn">{{ $t('key1000555') }}</Button>
      </div>
      <!--入库分拣设置弹窗-->
      <Modal v-model="sortSettingsModal" :title="$t('key1002641')" width="400"
        :transfer="false" :mask-closable="false" @on-visible-change="sortSettingsChange">
        <Form ref="sortSettingsModalForm" :model="sortSettingsModalForm" :label-width="100" @submit.native.prevent>
          <Row style="width: 80%;">
            <h2 style="margin: 0 0 10px 39px;">{{ $t('key1002663') }}</h2>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1002642')" prop="pickingNumber">
                <InputNumber :max="9999999" :min="1" v-model="sortSettingsModalForm.pickingNumber" :placeholder="$t('key1000836')"
                  :formatter="value => `${parseInt(value)}`" style="width: 50%;"></InputNumber>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1002643')" prop="packingNumber">
                <InputNumber :max="9999999" :min="1" :formatter="value => `${parseInt(value)}`" :placeholder="$t('key1000836')"
                  v-model="sortSettingsModalForm.packingNumber" style="width: 50%;"></InputNumber>
              </Form-item>
            </Col>
          </Row>
        </Form>
        <template #footer>
          <Button @click="sortSettingsModal = false">{{ $t('key1000112') }}</Button>
          <Button type="primary" @click="sortSettingsModal = false">{{ $t('key1000111') }}</Button>
        </template>
      </Modal>
    </div>
    <div v-else>
      <h3 class="flex justify-content-center align-items-center mt100 font-size-22 redColor">{{ $t('key1002664') }}</h3>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import {getEnableWarehouseData} from "@/utils/common";

export default {
  name: "processConfiguration",
  mixins: [Mixin],
  data() {
    return {
      warehouseName: '',
      ymsWarehouseId: null,
      ymsWarehouseData: [],
      extremeDeliveryMode: 0, // 极速出库模式
      sortingSticker: 0, // 分拣时进行贴单
      singleItemTask: true,
      sortSettingsModal: false,
      sortSettingsModalForm: {
        packingNumber: null,
        pickingNumber: null
      },
      disabledTalg: false,
      originalData: [],
      verificationTalg: false, // 记录当前页面数据是否有变更
    };
  },
  computed: {
    warehouseListTalg() {
      return this.ymsWarehouseData.length > 0;
    },
  },
  created() {
    this.getYmsWarehouseData();
  },
  methods: {
    // 获取用户入库配置
    getConfigurationData(ymsWarehouseId) {
      let v = this;
      v.resetData();
      v.getYmsPickupOrderData();
      v.axios.get(api.get_erpCommonSettingParam_queryPickupParam + ymsWarehouseId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data && data.length > 0) {
            v.originalData = data;
            let keyList = ['packingNumber', 'pickingNumber'];
            data.map((item) => {
              item.paramKey = item.paramKey.split(ymsWarehouseId)[0];
              if (keyList.includes(item.paramKey)) {
                v.sortSettingsModalForm[item.paramKey] = Number(item.paramValue) === 0 ? null : Number(item.paramValue);
              }
              if (item.paramKey === 'changePickupOrder') {
                v.sortingSticker = Number(item.paramValue);
              }
              if (item.paramKey === 'fastDeliveryStatus') {
                v.extremeDeliveryMode = Number(item.paramValue);
              }
            });
          }
        }
      });
    },

    // 查看是否有分拣中提单
    getYmsPickupOrderData() {
      let v = this;
      v.disabledTalg = false;
      v.axios.get(api.get_ymsPickupOrder_checkSortingOrder).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data && data.length > 0) {
            let ymsWarehouseIdList = data.map((item) => {
              return item.ymsWarehouseId;
            });
            if (ymsWarehouseIdList.includes(v.ymsWarehouseId)) {
              v.disabledTalg = true;
            }
          }
        }
      });
    },

    // 重置数据
    resetData() {
      let v = this;
      this.originalData = [];
      this.extremeDeliveryMode = 0;
      this.sortingSticker = 0;
      v.$nextTick(() => {
        v.$refs['sortSettingsModalForm'].resetFields();
      });
    },

    // 获取已启用的仓库
    getYmsWarehouseData() {
      getEnableWarehouseData(1).then((data) => {
        this.ymsWarehouseData = data || [];
        if (this.ymsWarehouseData.length > 0) {
          this.ymsWarehouseId = this.ymsWarehouseData[0].ymsWarehouseId;
          this.warehouseName = this.ymsWarehouseData[0].name;
          this.getConfigurationData(this.ymsWarehouseId);
        }
      });
    },
    // 切换仓库
    warehouseChange(value) {
      this.ymsWarehouseId = value;
      this.ymsWarehouseData.map((item) => {
        if (item.ymsWarehouseId === value) {
          this.warehouseName = item.name;
          this.getConfigurationData(this.ymsWarehouseId);
        }
      });
    },
    // 保存按钮
    processConfigurationBtn() {
      let v = this;
      let query = {
        ymsWarehouseId: v.ymsWarehouseId,
        changePickupOrder: v.sortingSticker, // 分拣贴单 0 未开启 1 已开启
        fastDeliveryStatus: v.extremeDeliveryMode, // 极速出库状态 0 未开启 1已开启
        packingNumber: v.sortSettingsModalForm.packingNumber, // 包装数
        pickingNumber: v.sortSettingsModalForm.pickingNumber // 拣货数
      };
      // 如果存在正在分拣中的任务，不允许修改分拣设置
      if (v.disabledTalg) {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002640'));
        return false;
      } else {
        v.axios.post(api.post_erpCommonSettingParam_saveOrUpdatePickupParam, query, {loading: true, loadignText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
            v.getConfigurationData(v.ymsWarehouseId);
          }
        });
      }
    },
    // 监听入库分拣设置的弹窗
    sortSettingsChange(value) {
      if (value) {
        if (!this.sortSettingsModalForm.pickingNumber) {
          this.sortSettingsModalForm.pickingNumber = null;
        }
        if (!this.sortSettingsModalForm.packingNumber) {
          this.sortSettingsModalForm.packingNumber = null;
        }
      }
    },
    // 新增虚拟库位库区
    addVirtualWarehouse() {
      let v = this;
      if (v.ymsWarehouseId) {
        v.axios.put(api.put_ymsWarehouse_addVirtualWarehouse + v.ymsWarehouseId).then(response => {
          if (response.data.code === 0) {
          }
        });
      }
    },
    // 校验当前页面是否有数据变更
    verificationData() {
      let v = this;
      let data = v.originalData;
      v.verificationTalg = false;
      if (data && data.length > 0) {
        let keyList = ['packingNumber', 'pickingNumber'];
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          item.paramKey = item.paramKey.split(v.ymsWarehouseId)[0];
          if (keyList.includes(item.paramKey)) {
            let value = Number(item.paramValue) === 0 ? null : Number(item.paramValue);
            if (v.sortSettingsModalForm[item.paramKey] !== value) {
              v.verificationTalg = true;
              return false;
            }
          }
          if (item.paramKey === 'changePickupOrder') {
            if (v.sortingSticker !== Number(item.paramValue)) {
              v.verificationTalg = true;
              return false;
            }
          }
          if (item.paramKey === 'fastDeliveryStatus') {
            if (v.extremeDeliveryMode !== Number(item.paramValue)) {
              v.verificationTalg = true;
              return false;
            }
          }
        }
      }
    },
    // 跳转到指定页面
    updateJumpPage(to, from, next, url) {
      let v = this;
      v.verificationData();
      if (v.verificationTalg) {
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000701'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000702'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000903'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            next();
          },
          onCancel: () => {
            window.location.href = url;
          }
        });
      } else {
        next();
      }
    }
  },
  watch: {
    extremeDeliveryMode: {
      handler(value) {
        if (!value) {
          this.sortingSticker = false;
        } else {
          this.addVirtualWarehouse();
        }
      },
      immediate: true,
      deep: true
    }
  },
  beforeRouteLeave(to, from, next) {
    let v = this;
    let url = window.location.href;
    let path = v.$route.path;
    if (path === '/processConfiguration') {
      v.updateJumpPage(to, from, next, url);
    } else {
      next();
    }
  }
};
</script>

<style lang="less" scoped>
.container_box {
  padding-bottom: 40px;
}

.flowChart_box {
  width: 1300px;
  position: relative;
}

.processConfiguration_content {
  position: relative;
}

.options_content {
  position: fixed;
  min-width: 100%;
  z-index: 10;
  background-color: #fff;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 15px;
}

.select_warehouse_box {
  padding: 10px 0 10px 0px;
  display: flex;
  align-items: center;

  .title {
    color: #333;
    font-size: 20px;
    font-weight: bold;
    margin-right: 25px;
  }
}

.processConfiguration_box {
  display: flex;
  align-items: center;
}

.erect_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0 0 337px;
  width: 200px;
}

.processConfiguration_box_item {
  border-radius: 8px;
  background-color: #fff;
  width: 210px;
  height: 120px;
  padding: 10px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 100;

  .title {
    font-size: 20px;
    color: #333;
  }

  .text {
    color: #2D8CF0;
    font-size: 13px;
    cursor: pointer;
    display: inline-block;
    position: absolute;
    top: 20px;
    right: 20px;
  }

  .process_status_box {
    color: #666;
    font-size: 12px;
    margin-top: 3px;
  }
}

.right_arrow_box {
  display: flex;
  align-items: center;

  .line_box_style {
    display: inline-block;
    width: 100px;
    height: 3px;
    background-color: #0099CC;
  }

  .arrow_style {
    display: inline-block;
    width: 22px;
    height: 20px;
    background-color: #0099CC;
    clip-path: polygon(0 0, 0 100%, 100% 50%);
  }
}

.left_arrow_box {
  display: flex;
  align-items: center;

  .line_box_style {
    display: inline-block;
    width: 80px;
    height: 3px;
    background-color: #0099CC;
  }

  .arrow_style {
    display: inline-block;
    width: 22px;
    height: 20px;
    background-color: #0099CC;
    clip-path: polygon(100% 100%, 0 50%, 100% 0);
  }
}

.down_arrow_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .line_box_style {
    display: inline-block;
    width: 3px;
    height: 60px;
    background-color: #0099CC;
  }

  .arrow_style {
    display: inline-block;
    width: 22px;
    height: 20px;
    background-color: #0099CC;
    clip-path: polygon(50% 100%, 0 0, 100% 0);
  }
}

.arrow_style_green {
  display: inline-block;
  width: 22px;
  height: 20px;
  background-color: #70B603;
  clip-path: polygon(50% 100%, 0 0, 100% 0);
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
}

.straight_corner_box {
  width: 200px;
  height: 3px;
  background-color: #70B603;
  position: absolute;
  top: 0;
  right: 137px;

  &:before {
    content: ' ';
    display: inline-block;
    width: 25px;
    height: 25px;
    border-top: 3px solid #70B603;
    border-right: 3px solid #70B603;
    border-top-right-radius: 10px;
    position: absolute;
    right: -23px;
  }
}

.straight_line_1 {
  position: absolute;
  top: 25px;
  right: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:before {
    content: ' ';
    display: inline-block;
    height: 180px;
    width: 3px;
    background-color: #70B603;
  }

  &:after {
    content: ' ';
    display: inline-block;
    height: 235px;
    width: 3px;
    background-color: #70B603;

  }

}

.straight_line_2 {
  position: absolute;
  top: 60px;
  right: 344px;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:before {
    content: ' ';
    display: inline-block;
    height: 180px;
    width: 3px;
    background-color: #70B603;
  }

  &:after {
    content: ' ';
    display: inline-block;
    height: 201px;
    width: 3px;
    background-color: #70B603;

  }

}

.straight_line_3 {
  position: absolute;
  top: 239px;
  right: 217px;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:before {
    content: ' ';
    display: inline-block;
    height: 110px;
    width: 107px;
    border-top: 3px solid #70B603;
    border-right: 3px solid #70B603;
    border-top-right-radius: 10px;
    position: absolute;
    left: -65px;
    top: -110px;
  }

  &:after {
    content: ' ';
    display: inline-block;
    height: 110px;
    width: 107px;
    border-bottom: 3px solid #70B603;
    border-right: 3px solid #70B603;
    border-bottom-right-radius: 10px;
    position: absolute;
    left: -65px;
    bottom: -110px;
  }

}

.straight_line_4 {
  position: absolute;
  top: 61px;
  right: 390px;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:before {
    content: ' ';
    display: inline-block;
    height: 270px;
    width: 3px;
    background-color: #70B603;
  }
}

.straight_line_5 {
  position: absolute;
  top: 330px;
  right: 447px;
  display: flex;
  align-items: center;

  .line_box_style {
    display: inline-block;
    width: 200px;
    height: 3px;
    background-color: #70B603;
  }

  .arrow_style {
    display: inline-block;
    width: 22px;
    height: 20px;
    background-color: #70B603;
    clip-path: polygon(100% 100%, 0 50%, 100% 0);
  }
}

.straight_line_6 {
  position: absolute;
  top: 270px;
  right: 460px;

  &:before {
    position: absolute;
    top: 7px;
    left: -69px;
    content: ' ';
    display: inline-block;
    height: 63px;
    width: 65px;
    border-left: 3px solid #70B603;
    border-top: 3px solid #70B603;
    border-top-left-radius: 10px;
  }

  &:after {
    position: absolute;
    top: 8px;
    right: -44px;
    content: ' ';
    display: inline-block;
    height: 3px;
    width: 40px;
    background-color: #70B603;
  }
}

.shelving_container_box {
  position: absolute;
  left: 542px;
  top: 140px;
  width: 200px;
  height: 120px;
  display: flex;
  align-items: center;

  .vertical_line {
    height: 57px;
    width: 3px;
    display: inline-block;
    background-color: #0099CC;
    position: absolute;
    top: -20px;
    right: 0;

    &::before {
      content: ' ';
      display: inline-block;
      width: 40px;
      height: 25px;
      border-right: 3px solid #0099CC;
      border-bottom: 3px solid #0099CC;
      border-bottom-right-radius: 10px;
      position: absolute;
      right: 0;
      bottom: -25px;
    }
  }

  .sticker_item {
    position: absolute;
    top: 10px;
    right: 43px;

    .sticker_line {
      display: inline-block;

      &::before {
        content: ' ';
        display: inline-block;
        position: absolute;
        top: 9px;
        left: -20px;
        width: 15px;
        height: 40px;
        border-left: 3px solid #0099CC;
        border-top: 3px solid #0099CC;
        border-top-left-radius: 10px;
      }

      &::after {
        content: ' ';
        display: inline-block;
        width: 37px;
        height: 3px;
        background-color: #0099CC;
        position: absolute;
        top: 9px;
        right: -42px;
      }
    }
  }

}

.extreme_delivery_box {
  position: absolute;
  right: 88px;
  top: 60px;
  width: 670px;
  height: 478px;
}
</style>